module.exports = __webpack_public_path__ + "media/images/ac_templates/201/mgrnh-93826aa274f6f18a5d1a37303424c30c.jpg";